const getUserType = type => {
  if (type.includes('physician')) return 'physician';
  if (type.includes('patient')) return 'patient';
  return 'staff';
};

export default getUserType;
